const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const MessageModal = require("./MessageModal");
const ChooseOptionModal = require("./ChooseOptionModal");
const StartTestModal = require("./StartTestModal");
const ContinuousPlayStreakModal = require("./ContinuousPlayStreakModal");
const Checkbox = require("./Checkbox");
const UserRateLimitModal = require("./UserRateLimitModal");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const withSetURL = require("../hoc/withSetURL");
const AT = require("../vault/ActionTypes");
const {atPage, atUser} = require("../vault/StateCursors");
const Derived = require("../vault/Derived");
const OpsPage = require("../vault/OpsPage");
const OpsUser = require("../vault/OpsUser");
const URLMake = require("../../../shared/URLMake");
const CopyTable = require("../util/CopyTable");
const CopyShared = require("../util/CopyShared");
const AssetsUtil = require("../util/AssetsUtil");
const {
	AUTH_TOO_MANY_REQUESTS_BAN_LENGTH,
} = require("../../../shared/Constants");

const styles = require("./styles/GlobalModal.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withSetURL(Component);
	Component = withVaultUpdate(Component, (props, vaultState) => ({
		user: atUser(vaultState).get(),
		page: atPage(vaultState).get(),
		styleType: Derived.getCurrentModalStyle(vaultState),
	}));
	return Component;
};
const GlobalModalInner = createReactClass({
	displayName: "GlobalModal",

	propTypes: {
		// Injected by HOCs
		user: PT.object.isRequired,
		page: PT.object.isRequired,
		styleType: PT.string.isRequired,
		dispatch: PT.func.isRequired,
		setURL: PT.func.isRequired,
	},

	// Used by vault update HOC
	vaultEvents: {
		showMessage: function(messageType, messageData) {
			if (this.isModalFrozen()) {
				return;
			}
			this.setState({
				isModalOpen: true,
				isConfirm: false,
				messageType,
				messageData,
			});
		},
		showConfirm: function(messageType, messageData) {
			if (this.isModalFrozen()) {
				return;
			}
			this.setState({
				isModalOpen: true,
				isConfirm: true,
				messageType,
				messageData,
			});
		},
		sessionExpired: function() {
			// This event also in LoginModal, but LoginModal only in
			// MainOfficeContainer
			if (this.isModalFrozen()) return;
			this.setState({
				isModalOpen: true,
				isConfirm: false,
				sessionExpired: true,
				messageType: null,
				messageData: null,
			});
		},
		sessionNotPlaying: function() {
			if (this.isModalFrozen()) return;
			this.setState({
				isModalOpen: true,
				isConfirm: false,
				messageType: "sessionNotPlaying",
				messageData: {
					refreshOnClose: true,
				},
			});
		},
		resetVaultState: function() {
			if (this.isModalFrozen()) return;
			this.closeSessionModal();
		},
	},

	// A check to perform before any new setStates triggered by vault events,
	// checks if the current modal on the screen cannot be closed.
	isModalFrozen: function() {
		return _.get(this.state, "messageData.cannotClose", false);
	},

	getInitialState: function() {
		return {
			isModalOpen: false,
			isConfirm: false,
			sessionExpired: false,
			messageType: null,
			messageData: null,
			doNotShowAgain: false,
		};
	},

	componentDidMount: function() {
		this.props.dispatch({type: AT.CHECK_BROWSER});
	},

	handleLogin: function() {
		if (global.window) {
			window.location.href = URLMake.forLogin(
				OpsUser.getStudentDomain(this.props.user)
			);
		}
	},

	closeSessionModal: function() {
		this.setState({
			isModalOpen: false,
			sessionExpired: false,
			messageType: null,
			messageData: null,
		});
	},

	toggleDoNotShow: function() {
		this.setState({doNotShowAgain: !this.state.doNotShowAgain});
	},

	onClose: function() {
		const {messageData, doNotShowAgain} = this.state;
		if (global.window && messageData && messageData.refreshOnClose) {
			const leftPage = OpsPage.leaveProblem(this.props.page);
			window.location.href = URLMake.forPageState(leftPage);
		} else {
			if (messageData && messageData.onCloseDispatch) {
				if (messageData.doNotShowAgainOption) {
					// Only call the dispatch in this case if user clicked the "do not show again option"
					if (doNotShowAgain) {
						this.props.dispatch(messageData.onCloseDispatch);
					}
				} else {
					this.props.dispatch(messageData.onCloseDispatch);
				}
			}
			this.setState({isModalOpen: false});
		}
	},

	onConfirm: function() {
		if (this.state.messageData && this.state.messageData.onConfirmDispatch) {
			this.props.dispatch(this.state.messageData.onConfirmDispatch);
		}
		this.setState({isModalOpen: false});
	},

	onNotConfirm: function() {
		if (this.state.messageData && this.state.messageData.onNotConfirmDispatch) {
			this.props.dispatch(this.state.messageData.onNotConfirmDispatch);
		}
		this.setState({isModalOpen: false});
	},

	shouldShowStartTestCardModal: function() {
		if (!OpsUser.isFamilySubscriptionStudent(this.props.user)) {
			return false;
		}
		if (!this.state.isConfirm) {
			return false;
		}
		const {messageType} = this.state;
		return messageType === "startTest" || messageType === "startRepeatTest";
	},

	render: function() {
		let modal = null;
		const refreshOnClose =
			this.state.messageData && this.state.messageData.refreshOnClose;
		const cannotClose = _.get(this.state, "messageData.cannotClose", false);
		if (this.state.isModalOpen) {
			const styleType = this.props.styleType || "default";
			if (this.state.sessionExpired) {
				modal = (
					<MessageModal
						styleType="default"
						backdropClass={styles.darkerBackdrop}
						cannotClose={true}
						levelType="aboveAll"
						portalContainer={null}
						buttonType="login"
						buttonClickHandler={this.handleLogin}
					>
						{CopyTable.forSessionExpired()}
					</MessageModal>
				);
			} else {
				const useStartTestCardModal = this.shouldShowStartTestCardModal();
				if (useStartTestCardModal) {
					const {
						baLevel,
						chapter,
						chapterName,
						isLastChapterInLevel,
						isFinalAcademyTest,
					} = this.state.messageData;
					const isRepeat = this.state.messageType === "startRepeatTest";
					modal = (
						<StartTestModal
							gradeNumber={baLevel}
							chapter={chapter}
							chapterName={chapterName || ""}
							styleType={this.state.messageData.styleType || styleType}
							isRepeat={isRepeat}
							isLastChapterInLevel={!!isLastChapterInLevel}
							isFinalAcademyTest={!!isFinalAcademyTest}
							onConfirm={this.onConfirm}
							onNotConfirm={this.onNotConfirm}
							onClose={this.onClose}
						/>
					);
				} else if (this.state.isConfirm) {
					const messageInfo = CopyTable.forConfirmMessageType(
						this.state.messageType,
						this.state.messageData
					);
					messageInfo.message = CopyShared.parseNewlinesToReact(
						messageInfo.message
					);
					modal = (
						<ChooseOptionModal
							styleType={this.state.messageData.styleType || styleType}
							size="large"
							buttons={[
								{
									buttonType: messageInfo.buttonTypes[0],
									handleClick: this.onConfirm,
								},
								{
									buttonType: messageInfo.buttonTypes[1],
									handleClick: this.onNotConfirm,
								},
							]}
							onClose={this.onClose}
							portalContainer={null}
						>
							{messageInfo.message}
						</ChooseOptionModal>
					);
				} else if (
					this.state.messageType === "continuousPlayHallwayCelebrateStreak"
				) {
					const {
						styleType: messageDataStyleType,
						totalStarsEarnedInStreak,
						nextLessonButtonProps,
					} = this.state.messageData || {};
					modal = (
						<ContinuousPlayStreakModal
							user={this.props.user}
							styleType={messageDataStyleType || styleType}
							totalStarsEarnedInStreak={totalStarsEarnedInStreak}
							onClose={this.onClose}
							nextLessonButtonProps={nextLessonButtonProps}
							setURL={this.props.setURL}
						/>
					);
				} else if (this.state.messageType === "pageNotFound") {
					//See hardcoded copy in CopyTable.js
					modal = (
						<MessageModal
							styleType="generic"
							size="text-generic"
							onClose={this.onClose}
							levelType="aboveAll"
							backdropClass={styles.darkerBackdrop}
							cannotClose={cannotClose}
							portalContainer={null}
							buttonType={"ok"}
						>
							<div className={styles.wrapper}>
								<img
									className={styles.errorImage}
									src={AssetsUtil.getGotProblems()}
								/>
								<div className={styles.errorMessage}>
									Oops!
									<div className={styles.errorBadURL}>
										{"beastacademy.com" + this.state.messageData}
									</div>
									does not exist.
								</div>
							</div>
						</MessageModal>
					);
				} else if (
					this.state.messageType === "testInProgress" ||
					this.state.messageType === "bookTestInProgress"
				) {
					let message = CopyTable.forErrorMessageType(
						this.state.messageType,
						this.state.messageData
					);
					message = CopyShared.parseNewlinesToReact(message);
					let destinationPageState;
					if (this.state.messageType === "testInProgress") {
						destinationPageState = URLMake.forTestBlockFromChapterID(
							this.state.messageData.chapterID
						);
					} else if (this.state.messageType === "bookTestInProgress") {
						destinationPageState = URLMake.forTestBlockFromMiscBlockName(
							this.state.messageData.miscBlockName
						);
					}
					const goToTest = () => {
						this.setState({
							isModalOpen: false,
							messageType: null,
							messageData: null,
						});
						this.props.setURL(destinationPageState);
					};
					modal = (
						<MessageModal
							styleType={styleType}
							onClose={goToTest}
							cannotClose={true}
							levelType={"aboveAll"}
							portalContainer={null}
							modalClass={null}
							size={"extra-extra-large"}
							buttonType={"continue"}
							buttonText={"continue test"}
						>
							{message}
						</MessageModal>
					);
				} else if (this.state.messageType === "userRateLimit") {
					modal = (
						<UserRateLimitModal
							initialSeconds={AUTH_TOO_MANY_REQUESTS_BAN_LENGTH}
						/>
					);
				} else if (this.state.messageType === "mustSignout") {
					const message = CopyTable.forErrorMessageType(
						this.state.messageType,
						this.state.messageData
					);
					modal = (
						<MessageModal
							styleType={styleType}
							onClose={() => {
								window.location.href = URLMake.forSignout({
									requestedURL: window.location.pathname,
								});
							}}
							cannotClose={true}
							levelType={"aboveAll"}
							portalContainer={null}
							modalClass={null}
							buttonType={"logout"}
							buttonText={"Sign Out"}
						>
							{message}
						</MessageModal>
					);
				} else {
					let message = CopyTable.forErrorMessageType(
						this.state.messageType,
						this.state.messageData
					);
					message = CopyShared.parseNewlinesToReact(message);
					const showOption = _.get(
						this.state.messageData,
						"doNotShowAgainOption",
						false
					);
					let checkboxEl;
					let buttonType = refreshOnClose ? "refresh" : "ok";
					const buttonTypeOverride = _.get(
						this.state,
						"messageData.buttonTypeOverride",
						null
					);
					if (buttonTypeOverride) buttonType = buttonTypeOverride;
					if (cannotClose) {
						buttonType = null;
					}
					if (showOption) {
						checkboxEl = (
							<Checkbox
								className={styles.checkbox}
								text="Do not show this message again"
								isSelected={this.state.doNotShowAgain}
								onClick={this.toggleDoNotShow}
								checkColor="red"
								styleType="trainer"
								textClass={styles.checkText}
							/>
						);
					}
					const modalClass =
						this.state.messageType === "browserNotSupported"
							? styles.fullScreenModal
							: null;
					modal = (
						<MessageModal
							styleType={styleType}
							onClose={this.onClose}
							cannotClose={cannotClose}
							levelType={cannotClose ? "aboveAll" : "default"}
							portalContainer={null}
							modalClass={modalClass}
							size={
								showOption
									? "large"
									: _.get(this.state, "messageData.modalSize", "medium")
							}
							buttonType={buttonType}
						>
							{message}
							{checkboxEl}
						</MessageModal>
					);
				}
			}
		}
		return modal;
	},
});
module.exports = augment(GlobalModalInner);
